// extracted by mini-css-extract-plugin
module.exports = {"CustomEvent":"CustomEvent__2E1Go","CustomEvent__label":"CustomEvent__label__3h3b8"};